<template>
  <div style="padding:1rem 1.6rem;page-break-after:always;page-break-before:always;height:18.8rem;background:#fff;position:relative;"><!--56.69-->
  <div v-if="reportInfo.language==='English'">
    <div style="">
      <div style="float:right;over-flow:hidden;transform:scale(0.5,0.5);margin-right:-2.4rem;margin-top:0rem;">
        <p style="font-size:0.8rem;font-family:Times New Roman;text-align:right;">
          Report No.：
        {{reportInfo.report_display_no}}</p>
      </div>
    </div>
    <div style="padding:1.2rem 0 0.3rem 0;">
      <p style="font-size:1rem;font-weight:500;font-family:Times New Roman;text-align:center;">Test Report</p>
    </div>
    <div style="text-align:justify;word-wrap:break-word;transform:scale(0.5,0.5);margin-left:-50%;width:200%;transform-origin:top;" ><slot></slot><div v-html="pageBreak"></div><slot name="signature"></slot></div>
    <div style="text-align:center;transform:scale(0.4,0.4);position:absolute;bottom:0.4rem;right:0.4rem;">
      <p style="font-size:0.8rem;font-family:KaiTi;">
        <span style="padding-right:0.2rem;">Page</span>
      <span style="padding-right:0.2rem;">{{currentPage}}</span>
      <span style="padding-right:0.2rem;">of</span>
      <span style="padding-right:0.2rem;">{{reportInfo.totalPage}}</span></p>
    </div>
  </div>
    <div v-else style="">
      <div style="position:absolute;top:1rem;right:0;display:flex;transform:scale(0.6,0.6);margin-right:0.2rem;">
        <div style="text-align:left;">
          <p style="font-size:0.6rem;font-family:KaiTi;">报告编号：</p>
          <p style="font-size:0.4rem;font-family:Times New Roman;">Report No.</p>
        </div>
        <div style="float:right;font-size:0.6rem;font-family:Times New Roman;position:relative;">{{reportInfo.report_display_no}}</div>
      </div>
    <div style="">
      <p
        style="font-size:0.8rem;font-weight:600;margin-top:1.2rem;text-align:center;font-family:'SimSun';"
      >检&nbsp;&nbsp;测&nbsp;&nbsp;报&nbsp;&nbsp;告</p>
      <p style="font-size:0.6rem;font-weight:500;font-family:Times New Roman;margin-top:0.1rem;">Test Report</p>
    </div>
    <div style="text-align:justify;word-wrap:break-word;transform:scale(0.5,0.5);margin-left:-50%;width:200%;transform-origin:top;" ><slot></slot><div v-html="pageBreak"></div><slot name="signature"></slot></div>
    <div style="text-align:center;transform:scale(0.4,0.4);position:absolute;bottom:0.1rem;right:0;">
      <p style="font-size:0.8rem;font-family:KaiTi;">第{{currentPage}}页 共{{reportInfo.totalPage}}页</p>
      <p
        style="font-size:0.8rem;font-family:Times New Roman;"
      >Page&nbsp;&nbsp;&nbsp;&nbsp;of&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    </div>
    </div>
  </div>
</template>
<script>
const finishHtml =
  "<p style='font-size:14pt;text-align:center;font-family:KaiTi;'>（完结）</p><div style='width:100pt;margin:0 auto;border-top:1px solid #000;'></div>";
const continueHtml =
  "<p style='font-size:14pt;text-align:center;font-family:KaiTi;'>（接下页）</p>";
export default {
  name: "normalPage",
  props: {
    reportInfo: {
      type: Object,
      default(){
        return {
        sampleName: "样品",
        contractNo: NaN,
        report_display_no:"",
        project_display_no:'',
        sampleAmount: "1",
        testLocation: "广粤支路87号",
        receiptDate: "",
        testDate: "",
        sampleInfo: "",
        language:"中文(简体)",
        standardList: [],
        totalPage: 1
      };
      }
    },
    currentPage:{
      type:Number,
      default:0
    },
    qrCodeUrl:{
      type:String,
      default:"nonValid"
    }
  },
  components: {},
  data() {
    return {
      
    };
  },
  methods: { 
  },
  computed: {
    pageBreak() {
      if (this.currentPage === this.reportInfo.totalPage) {
        return finishHtml;
      } else {
        return continueHtml;
      }
    },
  }
};
</script>
<style scoped>
div,p{
  padding: 0;
  margin:0;
}
</style>